/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { AddWhite, EditIcon, SearchIcon, ToggleOffIcon, ToggleOnIcon, TrashIcon, ViewIcon } from '../../../assets/icons';
import { Constants, getUpdatedState, Globals } from '../../../utils';
import { Input, Modal, Pagination } from '../../../components';
import { UserService } from '../../../services';
import ModalCreateDriver from './modal-create-driver';
import ModalViewDriver from './modal-view-driver';

const MODAL = {
  NONE: 0,
  CREATE: 1,
  EDIT: 1,
  VIEW: 3,
};

const Drivers = ({ tabs }) => {
  const [modal, setModal] = useState(MODAL.NONE);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const { data, deleteItem, filters, goToPage, onChange, pagination, reload, search, updateStatus } = useFetchTable();

  const handleModal = (modal, item) => {
    setSelectedItem(item || null);
    setModalKey(k => k + 1);
    setModal(modal);
  }

  return (
    <main className="w-full">
      <Modal isOpen={modal === MODAL.CREATE || modal === MODAL.EDIT} onClose={() => handleModal(MODAL.NONE)}>
        <ModalCreateDriver
          key={modalKey}
          initialData={selectedItem}
          onClose={() => handleModal(MODAL.NONE)}
          onSuccess={reload}
        />
      </Modal>

      <Modal isOpen={modal === MODAL.VIEW} onClose={() => handleModal(MODAL.NONE)}>
        <ModalViewDriver
          key={modalKey}
          item={selectedItem}
          onClose={() => handleModal(MODAL.NONE)}
          onEdit={() => handleModal(MODAL.EDIT, selectedItem)}
          onDelete={() => {
            deleteItem(selectedItem.id);
            handleModal(MODAL.NONE);
          }}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="grid grid-cols-[2fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Buscar nombre, CI"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            placeholder="Placa del vehículo"
            value={filters.plaque}
            onValueChange={v => onChange('plaque', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      {tabs}

      <div className="bg-white rounded-2xl shadow-md mt-6 w-full">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Registro de Conductores</p>

          <button
            onClick={() => handleModal(MODAL.CREATE)}
            className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold"
          >
            <img src={AddWhite} className="w-4 h-4" alt="" />
            Nuevo
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th className="!pl-4">Nombre del conductor</th>
                <th>C.I.</th>
                <th>Correo</th>
                <th>Teléfono</th>
                <th>Dirección</th>
                <th>Placa vehículo asignado</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Tipo de vehículo</th>
                <th>Vencimiento de licencia</th>
                <th>Vencimiento de certificado médico</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <div className="pl-4">{item.person?.name}</div>
                  </td>
                  <td>{item.person?.document}</td>
                  <td title={item.email}>{item.email}</td>
                  <td>{item.person?.phone}</td>
                  <td title={item.person?.address_house}>{item.person?.address_house}</td>
                  <td>{item.person?.driver?.vehicle?.plaque}</td>
                  <td>{item.person?.driver?.vehicle?.brand}</td>
                  <td>{item.person?.driver?.vehicle?.model}</td>
                  <td>{item.person?.driver?.vehicle?.vehicle_types_sep?.map(x => x?.vehicle_type?.name)?.join(', ')}</td>
                  <td>{item.person?.driver?.license_expiration ? moment(item.person?.driver?.license_expiration).format('DD/MM/YYYY') : ''}</td>
                  <td>{item.person?.driver?.medical_cert_expiration ? moment(item.person?.driver?.medical_cert_expiration).format('DD/MM/YYYY') : ''}</td>
                  <td>
                    <div className="flex items-center gap-3 pr-4 min-w-max">
                      {item.status !== Constants.USER.STATUS.DISABLED ? (
                        <img
                          key={`${item.id}-on`}
                          src={ToggleOnIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.USER.STATUS.DISABLED)}
                          alt=""
                        />
                      ) : (
                        <img
                          key={`${item.id}-off`}
                          src={ToggleOffIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.USER.STATUS.SERVICE_OFF)}
                          alt=""
                        />
                      )}
                      <img
                        src={ViewIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => handleModal(MODAL.VIEW, item)}
                        alt=""
                      />
                      <img
                        src={EditIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => handleModal(MODAL.EDIT, item)}
                        alt=""
                      />
                      <img
                        src={TrashIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => deleteItem(item.id)}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    level_id: Constants.LEVELS.DRIVER,
    plaque: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await UserService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const deleteItem = async (id) => {
    Globals.confirm('¿Está seguro de que desea eliminar este conductor?', async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await UserService.admin.destroy(id);
        toast.success('Conductor eliminado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const updateStatus = async (id, status) => {
    const statusText = status === Constants.USER.STATUS.SERVICE_OFF ? 'activar' : 'desactivar';
    Globals.confirm(`¿Está seguro de que desea ${statusText} este usuario?`, async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await UserService.admin.updateStatus({ id, status });
        toast.success('Usuario actualizado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    deleteItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    updateStatus,
  }
}

export default Drivers;